import { render, staticRenderFns } from "./zuo.vue?vue&type=template&id=322fbfc8&scoped=true&"
import script from "./zuo.vue?vue&type=script&lang=js&"
export * from "./zuo.vue?vue&type=script&lang=js&"
import style0 from "./zuo.vue?vue&type=style&index=0&id=322fbfc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322fbfc8",
  null
  
)

export default component.exports